import React from 'react';
import './index.scss';
import { useSelector } from 'react-redux';
import { RootState } from '@/store';
const Error = () => {
  const { errorIcon, errorText, errorBtn, errorBtnClick } = useSelector(
    (state: RootState) => state.Error,
  );
  return (
    <div className="error">
      <img src={errorIcon} alt="" className="error__icon" />
      <p className="error__text">{errorText}</p>
      {errorBtn && (
        <p className="error__btn" onClick={errorBtnClick}>
          {errorBtn}
        </p>
      )}
    </div>
  );
};
export default Error;
